import React from 'react';

import {
    ChartOrEmptyMessage,
    LoadingSpinner,
    SummaryBar,
} from '@trqk/components';

interface DetectionsTotalsChartProps {
    height: number;
    /**
     * Array of DetectionTotal objects or null, to render in bar chart
     */
    detectionTotals: DetectionTotal[] | null;
    setTableDimensions(): void;
}

export const DetectionTotalsChart = ({
    height,
    detectionTotals,
    setTableDimensions,
}: DetectionsTotalsChartProps): JSX.Element | null => {
    if (!detectionTotals) {
        return (
            <div
                style={{
                    height,
                }}
                className="flex items-center justify-center w-full"
            >
                <LoadingSpinner />
            </div>
        );
    }

    return (
        <ChartOrEmptyMessage data={detectionTotals} height={height}>
            <SummaryBar<DetectionTotal>
                chartDivId="detection-totals-chart"
                data={detectionTotals}
                dataFields={{ category: 'filename', value: 'detections' }}
                height={height}
                onChartReady={setTableDimensions}
                tooltipLabels={{
                    category: 'Work Title / Audio',
                    value: 'Detections',
                }}
                zoomLevel={5}
            />
        </ChartOrEmptyMessage>
    );
};
